import {
  BulkReachoutTemplateVersion,
  IBulkReachoutActionParams,
} from "@shared/lib/types/pricingWorkload";

export type BulkReachoutTemplateFormValues = {
  templateVersion: BulkReachoutTemplateVersion;
  product: string;
  timeline: string;
  additionalMessage: string;
  separateDeliverables: string[];
};

export function buildBulkReachoutActionParams(
  values: BulkReachoutTemplateFormValues
): IBulkReachoutActionParams {
  const product = values.product.trim() || undefined;
  const timeline = values.timeline.trim() || undefined;
  const additionalMessage = values.additionalMessage.trim() || undefined;

  if (values.templateVersion === "v1") {
    return { templateVersion: "v1" };
  }

  if (values.templateVersion === "v2") {
    const templateParams = {
      ...(product ? { product } : {}),
      ...(timeline ? { timeline } : {}),
      ...(additionalMessage ? { additionalMessage } : {}),
    };

    return {
      templateVersion: "v2",
      ...(Object.keys(templateParams).length > 0 ? { templateParams } : {}),
    };
  }

  const separateDeliverables = values.separateDeliverables
    .map((item) => item.trim())
    .filter(Boolean);

  const templateParams = {
    ...(product ? { product } : {}),
    ...(timeline ? { timeline } : {}),
    ...(additionalMessage ? { additionalMessage } : {}),
    ...(separateDeliverables.length > 0 ? { separateDeliverables } : {}),
  };

  return {
    templateVersion: "v3",
    ...(Object.keys(templateParams).length > 0 ? { templateParams } : {}),
  };
}
